import { TestShackReportPage } from "./TestShackReportPage";

export default TestShackReportPage;
